import { render, staticRenderFns } from "./RealnameAudit.vue?vue&type=template&id=c9c86724&scoped=true"
import script from "./RealnameAudit.vue?vue&type=script&lang=js"
export * from "./RealnameAudit.vue?vue&type=script&lang=js"
import style0 from "./RealnameAudit.vue?vue&type=style&index=0&id=c9c86724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c86724",
  null
  
)

export default component.exports